import { AxiosError } from 'axios';
import type { ApiErrorResponse } from '@financial/shared';

/** Extrae un mensaje legible de un error de axios/API. */
export function getApiErrorMessage(error: unknown, fallback = 'Ocurrió un error'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    if (data?.message) {
      return Array.isArray(data.message) ? data.message.join(', ') : data.message;
    }
    if (error.code === 'ERR_NETWORK') {
      return 'No se pudo conectar con el servidor.';
    }
  }
  return fallback;
}
